import api from '@/api.js';
const state = {
    items: {}
};
const mutations = {
    list(state, items) {
        const t = {};
        items.forEach(i => {
            t[i.person] = t[i.person] || { count: 0, times: [] };
            t[i.person].times.push({ id: i.id, stamp: i.stamp });
            t[i.person].count++;
        });
        state.items = t;
    },
};
const getters = {
    items: (state) => state.items
};
const actions = {
    async list({ commit }) {
        const res = await api.tools.smoked();
        commit('list', res.data);
    },
    async add({ commit }, person) {
        await api.tools.smoke(person);
    }
};
export const Smoke = {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
};
